import React from 'react';
import { inject, observer } from 'mobx-react';
import * as mobx from 'mobx';
import { getAntd, getEcCom, getLabel } from '../../../util/convert';
import NodeInfoContent from './NodeInfoContent';

@inject('selectNextFlowStore')
@observer
export default class Main extends React.Component {
    render() {
        const { WeaDialog } = getEcCom();
        const { visible, selectNextFlowStore } = this.props;
        const { baseParams = {}, showNodeInfo } = selectNextFlowStore;
        let dialogHeight = '500px';
        return (
            <WeaDialog ecId={`${this && this.props && this.props.ecId || ''}_WeaDialog@hest5d`}
              visible={visible}
              loadCss={true}
              initLoadCss={true}
              title={getLabel(390987, '选择下一节点')}
              icon="icon-coms-workflow"
              iconBgcolor="#0079DE"
              maskClosable={false}
              onCancel={this.doCancel}
              style={{ width: '720px', height: dialogHeight }}
            >
                <NodeInfoContent ecId={`${this && this.props && this.props.ecId || ''}_NodeInfoContent@8p636d`} {...this.props} />
            </WeaDialog>
        );
    }
    doCancel = () => {
        const { selectNextFlowStore } = this.props;
        selectNextFlowStore.nodeInfoCancelEvent();
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/dialog/select-next-flow/NodeInfoDialog.js